module.exports = __webpack_public_path__ + "static/img/manual-36.353d78b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-36.png
// module id = SokU
// module chunks = 4